import styled from "styled-components";

export const StyledDiv = styled.div`
	border-radius: 100%;
	background-color: #${Math.floor(Math.random() * 16777215).toString(16)};
	color: #${Math.floor(Math.random() * 16777215).toString(16)};
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
`;
